import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { GET_SURVEY_QUESTION_OPTIONS } from '@pass-frontend/common/data-access';
import { SurveyQuestionOption } from '@pass-frontend/data-access/common/edge';
import { useGetAllSurveys } from './use-get-all-surveys';
import { useGetSurveyQuestions } from './use-get-survey-questions';

export function useGetSurveyQuestionOptions() {
  const { surveys } = useGetAllSurveys();
  const { fetchSurveyQuestions, surveyQuestions } = useGetSurveyQuestions();
  const CANCELLATION_SURVEY_QUESTIONS = '00000000-0000-000-000-000000000006';

  //This is for cancellation-reason-question
  useEffect(() => {
    if (surveys) {
      fetchSurveyQuestions(CANCELLATION_SURVEY_QUESTIONS);
    }
  }, [surveys, surveyQuestions]);

  const { loading, error, data } = useQuery<{
    surveyQuestionOptions: SurveyQuestionOption[];
  }>(GET_SURVEY_QUESTION_OPTIONS, {
    variables: {
      questionId: '00000000-0000-002-001-000000000000',
    },
  });

  return {
    loading: loading ?? false,
    error,
    surveyQuestionOptions: data,
  };
}
